import { environment } from 'environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import { IChatGetActiveResponse } from '../models/chat.models';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class ChatsActiveHub {

  public connectionEstablished: EventEmitter<Boolean>;
  public connectionExists: Boolean;
  public messageReceived: EventEmitter<IChatGetActiveResponse>;
  private chatConnection: signalR.HubConnection;

  constructor() {
    this.connectionEstablished = new EventEmitter<Boolean>();
    this.connectionExists = false;
    this.messageReceived = new EventEmitter<IChatGetActiveResponse>();

    // Создаем подключение к современному SignalR Hub
    this.chatConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.api + 'hubChatDashboard', {
        transport: signalR.HttpTransportType.ServerSentEvents,
        withCredentials: false // Для CORS с credentials
      })
      .withAutomaticReconnect()
      .build();

    this.registerOnServerEvents();
  }

  public connectToChatDashboard(clubId: string, pageSize: number) {
    this.startConnection(clubId, pageSize);
  }

  public disconnect() {
    this.chatConnection.stop();
  }

  private async startConnection(clubId: string, pageSize: number): Promise<void> {
    if (this.connectionExists) {
      await this.chatConnection.stop();
    }

    try {
      await this.chatConnection.start();
      await this.chatConnection.invoke('subscribeClub', { clubId, pageSize });
      this.connectionEstablished.emit(true);
      this.connectionExists = true;
    } catch (error) {
      console.error('ChatsActiveHub connection error:', error);
      this.connectionEstablished.emit(false);
    }
  }

  private registerOnServerEvents(): void {
    // Удаляем старые обработчики и добавляем новые
    this.chatConnection.off('messageReceived');
    this.chatConnection.on('messageReceived', (data: IChatGetActiveResponse) => {
      this.onMessageReceived(data);
    });
  }

  private onMessageReceived = (data: IChatGetActiveResponse) => this.messageReceived.emit(data);
}
